import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { FirebaseApp } from "firebase/app";
import MembersMenu from "./MembersMenu";
import ResultTextField from "./ResultTextField";
import ResultBar from "./ResultBar";
import { getFaceWithNameLink } from "../common/common";

type Props = {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  id: string;
  label: string;
  tooltip: string;
  firebaseApp: FirebaseApp;
};
function FaceWithName(props: Props) {
  const [open, setOpen] = useState(false);

  const { name, setName, id, label, tooltip, firebaseApp } = props;

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isSelected = () => name !== "";
  const getResultText = () => {
    if (isSelected()) {
      return getFaceWithNameLink(name);
    }

    return "";
  };

  return (
    <Box
      m="0.5rem"
      p="0.5rem"
      sx={{ backgroundColor: "#FFFFFF" }}
      boxShadow={3}
    >
      <Typography variant="h2">顔サムネ+リンク生成</Typography>
      <MembersMenu name={name} setName={setName} firebaseApp={firebaseApp} />
      <ResultTextField
        id={id}
        label={label}
        getOutputText={getResultText}
        handleClick={handleClick}
        tooltip={tooltip}
      />
      <ResultBar
        open={open}
        handleClose={handleClose}
        result={getResultText()}
        successMessage="クリップボードにコピーしました"
        errorMessage="配信者名が選択されていません"
      />
    </Box>
  );
}
export default FaceWithName;
